import { IComboBoxOption } from "@fluentui/react";
import { List } from "linq.ts";

/**
 * Tipo de asignación de permisos
 */
export enum PermissionAssignmentType {

    /**
     * Sin definir
     */
    none = 0,

    /**
     * Concede permisos a cualquier usuario autenticado en el sistema
     */
    allAuthenticatedUsers = 1,

    /**
     * Concede permisos a los usuarios que no están autenticados en el sistema
     */
    anonymousUsers = 2,

    /**
     * Concede permisos a un usuario
     */
    user = 3,

    /**
     * Concede permisos a un contacto (Uso exclusivo de la sede electrónica)
     */
    contact = 4,

    /**
     * Asigna permisos a una sección
     */
    section = 5,

    /**
     * Asigna permisos a un rol
     */
    role = 6,

    /**
     * Asigna permisos a un perfil
     */
    profile = 7,

    /**
     * Asigna permisos a un api de Procesox
     */
    api = 8

}

/**
 * Retorna el nombre de un tipo de asignación de permiso
 */
export const GetPermissionAssignmentString = (assignmentType: PermissionAssignmentType): string => {
    switch (assignmentType) {
        case PermissionAssignmentType.allAuthenticatedUsers: return 'All authenticated users';
        case PermissionAssignmentType.anonymousUsers: return 'Anonymous users';
        case PermissionAssignmentType.user: return 'User';
        case PermissionAssignmentType.contact: return 'Contact';
        case PermissionAssignmentType.section: return 'Section';
        case PermissionAssignmentType.role: return 'Role';
        case PermissionAssignmentType.profile: return 'Profile';
        case PermissionAssignmentType.api: return 'Api';
        default: return 'Not supported';
    }
}

export const PermissionAssignmentTypeDataSource: IComboBoxOption[] = new List<IComboBoxOption>([
    { key: PermissionAssignmentType.allAuthenticatedUsers, text: GetPermissionAssignmentString(PermissionAssignmentType.allAuthenticatedUsers) },
    { key: PermissionAssignmentType.anonymousUsers, text: GetPermissionAssignmentString(PermissionAssignmentType.anonymousUsers) },
    { key: PermissionAssignmentType.user, text: GetPermissionAssignmentString(PermissionAssignmentType.user) },
    { key: PermissionAssignmentType.contact, text: GetPermissionAssignmentString(PermissionAssignmentType.contact) },
    { key: PermissionAssignmentType.section, text: GetPermissionAssignmentString(PermissionAssignmentType.section) },
    { key: PermissionAssignmentType.role, text: GetPermissionAssignmentString(PermissionAssignmentType.role) },
    { key: PermissionAssignmentType.profile, text: GetPermissionAssignmentString(PermissionAssignmentType.profile) },
    { key: PermissionAssignmentType.api, text: GetPermissionAssignmentString(PermissionAssignmentType.api) }
]).OrderBy(x => x.text).ToArray();
